module.exports = __webpack_public_path__ + "img/menu-dem.eea9c985.svg";